import { render, staticRenderFns } from "./ModifyCustomer.vue?vue&type=template&id=4b910a23"
import script from "./ModifyCustomer.vue?vue&type=script&lang=js"
export * from "./ModifyCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports